import { memo } from 'react'
import { RaButton, RaContainer, RaRichText } from '@components/core/index.core'

import type { AcfCtaSectionProps } from '@typings'

import styles from './acf-cta-section.module.scss'

export const AcfCtaSection = memo(
  ({ cta, cta_color, text }: AcfCtaSectionProps) => {
    return (
      <RaContainer>
        <div className={styles['cta-section']}>
          {text && <RaRichText content={text} />}
          <RaButton
            link={cta}
            customColor={cta_color}
          />
        </div>
      </RaContainer>
    )
  }
)
